import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { FiHome, FiInfo, FiHelpCircle, FiPhone, FiSearch } from "react-icons/fi";

export default function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <header className={`header ${scrolled ? "scrolled" : ""}`}>
            <div className="header-container">

                {/* Logo */}
                <Link to="/" className="logo">
                    <FaHome />
                    <span>Washington AFH</span>
                </Link>

                {/* Desktop Nav */}
                <nav className={`nav ${isOpen ? "open" : ""}`}>
                    <Link to="/" onClick={() => setIsOpen(false)}><FiHome /> Home</Link>
                    <Link to="/search" className="mobile-only"
                        onClick={() => setIsOpen(false)}><FiSearch /> Find a Home
                    </Link>
                    <Link to="/about" onClick={() => setIsOpen(false)}><FiInfo /> About</Link>
                    <Link to="/help" onClick={() => setIsOpen(false)}><FiHelpCircle /> Help Center</Link>

                    <Link to="/contact" onClick={() => setIsOpen(false)}><FiPhone /> Contact</Link>
                </nav>

                {/* CTA */}
                <div className="header-right">
                    <Link to="/search" className="cta-btn">
                        Find a Home
                    </Link>

                    <div
                        className={`hamburger ${isOpen ? "active" : ""}`}
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

            </div>
        </header>
    );
}